export const errorsUri = {
  auth: 'error/auth',
  unknown: 'error/unknown',
  notEnough: 'error/not-enough',
  proposalNotFound: 'error/proposal-not-found',
  proposalCreate: 'error/proposal-create',
  proposalCreated: 'error/proposal-created',
  proposalSend: 'error/proposal-send',
  proposalRejected: 'error/proposal-rejected',
  pageNotFound: 'error/page-not-found',
  temporarilyUnavailable: 'error/temporarily-unavailable',
  questionnaireFillingTimeExpired: 'error/questionnaire-filling-time-expired',
  noPaymentRequirements: 'error/no-payment-requirements',
  messageLimitExpired: 'error/message-limit-expired',
};
